import React from "react";
import { useNavigate } from "react-router-dom";

export default function InactiveClubModal() {
  const navi = useNavigate();
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Inactive Club</p>
        </div>

        <button
          type="button"
          className="close-button"
          onClick={() => navi("/")}
          aria-label="Close"
        >
          &times;
        </button>
        <p>This club is currently unavailable.</p>

        <div className="send-modal-footer">
          <button
            onClick={() => navi("/")}
            className="pointer cancelButton fw-bold mx-2 px-3"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
